import { Observable } from 'rxjs';
import { AbstractScreenHandler, CRUDGenericService, TypeValidatorService } from 'attcei-bo-fw';
import { ScreenHandler } from 'attcei-bo-fw/lib/screen/interfaces/ScreenHandler';
import { Injectable } from '@angular/core';
import { PaginationState } from 'attcei-bo-fw/lib/classes/PaginationState';
import { Sort } from '@angular/material/sort';
import { PaginatedDTO } from 'attcei-bo-fw/lib/classes/dto/PaginatedDTO';
import { MeasurementDTO } from '../classes/dto/MeasurementDTO';

@Injectable({
    providedIn:'root'
})
export class MeasurementScreenHandler extends AbstractScreenHandler<MeasurementDTO, MeasurementDTO> implements ScreenHandler<MeasurementDTO, MeasurementDTO>{
    constructor(private service: CRUDGenericService, typeValidator: TypeValidatorService){
        super(typeValidator);
    }
    
    loadListData(filter: any, paginationState: PaginationState, sort: Sort): Observable<PaginatedDTO<MeasurementDTO>> {
        var url:string = this.getURL() + this.buildInvocationWithPaginationAndFilter(paginationState, filter, sort);
        return this.service.getDataList(url, true);
    }

    post(item: MeasurementDTO): Observable<MeasurementDTO> {
        console.log('Recebi no post -> ', item);
        var dto: MeasurementDTO = super.parse(item);
        var res: Observable<MeasurementDTO> = this.service.postData(this.getURL(),dto,true);
        console.log('result -> ', res);
        return res;
    }

    update(item: MeasurementDTO):Observable<MeasurementDTO> {
        console.log('Recebi no update -> ', item);
        var dto: MeasurementDTO = super.parse(item);
        var res: Observable<MeasurementDTO> = this.service.putData(this.getURL(), dto.id, dto, true);
        console.log('parsed -> ', res);
        return res;
    }

    delete(item: any):Observable<MeasurementDTO> {
        return this.service.delete(this.getURL(), item.id, true);
    }

    getItem(id: number):Observable<MeasurementDTO> {
        return this.service.getDataItem(this.getURL(), true, id);
    }

    getURL(): string {
        return 'measurement';
    }

    getId(item: MeasurementDTO): number {
        return item.id;
    }

    protected getUpdateTypeName(): string {
        return 'MeasurementDTO';
    }

    protected getCreateTypeName(): string {
        return 'MeasurementDTO';
    }
}